import type { FeedItem } from '@/types/api';

interface IdsResponse {
  ids: string[];
}

interface ItemsResponse {
  items: FeedItem[];
}

class ApiService {
  async fetchLocalForYou(zipcode: string): Promise<string[]> {
    const params = new URLSearchParams({ zipcode });
    const response = await fetch(`/api/feed/local-for-you?${params}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as IdsResponse;
    return data.ids || [];
  }

  async fetchCrimeNews(zipcode: string): Promise<string[]> {
    const params = new URLSearchParams({ zipcode });
    const response = await fetch(`/api/feed/crime-news?${params}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as IdsResponse;
    return data.ids || [];
  }

  async fetchContentDetails(ids: string[]): Promise<FeedItem[]> {
    if (ids.length === 0) return [];

    const response = await fetch('/api/feed/content-details', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as ItemsResponse;
    return data.items || [];
  }

  async fetchFeed(zipcode: string): Promise<FeedItem[]> {
    const response = await fetch(`/api/feed/full?zipcode=${zipcode}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as ItemsResponse;
    return data.items || [];
  }

  async fetchCrimeFeed(zipcode: string): Promise<FeedItem[]> {
    const response = await fetch(`/api/feed/crime-full?zipcode=${zipcode}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as ItemsResponse;
    return data.items || [];
  }
}

export const apiService = new ApiService();
